module.exports = __webpack_public_path__ + "static/media/actionresponse-org.d2aa982f.svg";